<template>
  <div class="sushi-diaoxian page">
    <div class="wrapper" style="border-right: none;">
      <template v-if="grid[1]">
        <div class="factions" v-if="type == 3">
          <div
            class="faction-wrapper"
            v-for="(item, index) in grid[1].factions"
            :key="index"
          >
            <div class="faction">
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="content">
          <div
            class="tree-content"
            :class="{ zhixi: type }"
            v-if="type == 3"
            :style="{
              transform: `translateX(${
                type === 3 ? `${grid[1].offset * 100}%` : `calc(${grid[1].offset * 100}% - ${grid[1].offset * 70}px)`
              }) rotateY(0deg)`,
            }"
          >
            <sushi-diaoxian-item-zhixi
              v-for="(item, index) in grid[1].list"
              :key="item.id"
              :list="item.list"
              :fatherIndex="
                index === 0
                  ? -1
                  : getFatherPosition(grid[1].list[index - 1].list)
              "
              :isFirst="true"
              :style="{
                height: `calc(100% / 7)`,
              }"
            />
          </div>
          <div
            v-else
            class="tree-content left"
            :style="{
              transform: `translateX(${
                type === 3 ? `${grid[1].offset * 100}%` : `calc(${grid[1].offset * 100}% - ${grid[1].offset * 70}px)`
              }) rotateY(0deg)`,
            }"
          >
            <sushi-diaoxian-item
              v-for="(item, index) in grid[1].tree"
              :key="index"
              :item="item"
              :isFirst="true"
              :isReverse="grid[1].isReverse"
            />
          </div>
        </div>
      </template>
    </div>
    <pu-info class="pu-info" :style="`width: 6%`" :puInfo="puInfo" />
    <div class="wrapper" style="border-left: none;">
      <template v-if="grid[0]">
        <div class="factions">
          <div
            class="faction-wrapper"
            v-for="(item, index) in grid[0].factions"
            :key="index"
          >
            <div class="faction">
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="content">
          <div
            class="tree-content"
            :class="{ zhixi: type }"
            v-if="type == 3"
            :style="{
              transform: `translateX(${
                type === 3 ? `${grid[0].offset * 99.8}%` : `calc(${grid[0].offset * 99.8}% - ${grid[0].offset * 65}px)`
              }) rotateY(0deg)`,
            }"
          >
            <sushi-diaoxian-item-zhixi
              v-for="(item, index) in grid[0].list"
              :key="item.id"
              :list="item.list"
              :fatherIndex="
                index === 0
                  ? -1
                  : getFatherPosition(grid[0].list[index - 1].list)
              "
              :isFirst="true"
              :style="{
                height: `calc(100% / 7)`,
              }"
            />
          </div>
          <div
            v-else
            class="tree-content"
            :style="{
              transform: `translateX(${
                type === 3 ? `${grid[0].offset * 100}%` : `calc(${grid[0].offset * 100}% - ${grid[0].offset * 66.5}px)`
              }) rotateY(0deg)`,
            }"
          >
            <sushi-diaoxian-item
              v-for="(item, index) in grid[0].tree"
              :key="index"
              :item="item"
              :isFirst="true"
              :isReverse="grid[0].isReverse"
            />
          </div>
        </div>
      </template>
    </div>
    <!-- <div v-for="(item, index) in grid" :key="index" class="grid">
      <div class="faction inner">
        <span>{{ splitText(item.name) }}</span>
      </div> -->
    <!-- <div
        class="inner name-wrapper"
        v-for="(person, index) in item.list"
        :style="`${index !== 0 && item.list[index - 1].child ? `margin-right: ${item.list[index - 1].child.length * 47 + (item.list[index - 1].spouseArrs ? item.list[index - 1].spouseArrs.length * 7 : 0)}px` : ''}`"
        :key="index"
      >
        <div class="name">
          <div
            class="has-father"
            :class="{
              'has-father-left':
                index !== 0 && isSameFather(person, item.list[index - 1]),
            }"
            
            v-if="person.is_zeng === 1 && person.father_id"
          ></div>
          {{ person.is_zeng === 1 ? person.name : person.username }}
          <div
            class="has-son"
            v-if="person.is_zeng === 1 && person.child && person.child.length"
          ></div>
        </div>
        <div
          class="name"
          v-for="(spouse, index) in person.spouseArrs"
          :key="index"
        >
          {{ spouse.is_zeng === 1 ? spouse.name : spouse.username }}
        </div>
      </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import SushiDiaoxianItem from "./SushiDiaoxianItem.vue";
import SushiDiaoxianItemZhixi from "./SushiDiaoxianItemZhixi.vue";
import PuInfo from "./PuInfo.vue";

export default {
  name: "Sushi-Diaoxian",
  components: {
    SushiDiaoxianItem,
    SushiDiaoxianItemZhixi,
    PuInfo,
  },
  props: {
    grid: {
      type: Array,
      default: () => [],
    },
    puInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      type: 1,
    };
  },
  computed: {},
  mounted() {
    this.type = this.$route.query.type; // 家庭/直系
  },
  methods: {
    splitText(str) {
      if (!str) return "";
      let strArr = str.split("");
      let offset = 0;
      while (offset < str.length) {
        offset += 2;
        strArr.splice(offset + Math.floor(offset / 2) - 1, 0, "\n");
      }
      return strArr.join("");
    },
    isSameFather(item1, item2) {
      return item1.father_id === item2.father_id;
    },
    getFatherPosition(list) {
      return list.findIndex((item) => item.gridChild);
    },
    getSonPosition(list) {
      console.log(list[0].father_id);
      return list[0].father_id;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  width: 47%;
  border: 3px solid #000;
  overflow: hidden;
  flex: none;
  position: relative;
}
.sushi-diaoxian {
  height: 100%;
  width: 100%;
  // transform: scale(0.738) translateY(15px);

  position: relative;
  background-color: #fff;
  display: flex;
  overflow: hidden;

  .factions {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    height: calc(100% - 6px);
    position: absolute;
    right: -5px;
    top: 3px;
    background-color: #fff;
    z-index: 100;
    padding-right: 20px;
    padding-left: 10px;

    // transform: scale(0.95);

    .faction-wrapper {
      height: calc(100% / 7);
      display: flex;
      align-items: center;
      flex: none;
    }

    .faction {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: none;
      text-align: left;
      white-space: pre;
      writing-mode: vertical-rl;
      width: 50px;
      height: 113px;
      border: 3px solid #ac0404;
      border-radius: 7px;
      font-size: 24px;
      font-weight: 600;
      color: #ac0404;
    }
  }

  .content {
    width: 638px;
    overflow: hidden;
    position: relative;
    // margin-left: 40px;
    height: 100%;
    transform: scaleX(0.97);
    // transform: scale(0.95);
  }

  .tree-content {
    // margin: 20px;
    display: flex;
    flex-flow: row-reverse nowrap;
    position: relative;
    // margin-right: -50px;
    padding-top: 50px;
    padding-right: 70px;

    &.left {
      padding-right: 20px;
    }

    // transform: scaleY(0.9);

    &.zhixi {
      flex-flow: column nowrap;
      height: 100%;
      padding: 0;
      padding-right: 70px;
      margin: 0;
    }
  }
}
</style>